import Colors from "../../../../../../global/Colors";

export const FilterListConfig = {
  search: {
    fieldName: "search",
    title: "Search",
    filterType: "Search",
    selectedValue: "",
    activeChip: {
      isActive: false,
      color: Colors.green[500],
      label: "",
      clearValueOnDelete: true,
    },
  },
  assigned_users: {
    fieldName: "assigned_users",
    title: "Assigned Users",
    filterType: "MultiSelectSearch",
    searchTitle: "User Search",
    showForm: false,
    options:[],
    selectedValue: [],
    checked: [],
    nameKey: "name",
    valueKey: "pk",
    apiUrl: `/api/users/all_assignable_users/?`,
    permissions: [],
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  role_id: {
    fieldName: "role_id",
    title: "Assigned Roles",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Assigned Roles",
    showForm: false,
    options:[],
    selectedValue: [],
    checked: [],
    nameKey: "name",
    valueKey: "pk",
    apiUrl: `/api/user_roles/?`,
    permissions: [],
    activeChip: {
      isActive: false,
      color: Colors.orange[500],
      label: "",
    },
  },
  role_id_not__in: {
    fieldName: "role_id_not__in",
    title: "Unassigned Roles",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Unassigned Roles",
    showForm: false,
    options:[],
    selectedValue: [],
    checked: [],
    nameKey: "name",
    valueKey: "pk",
    apiUrl: `/api/user_roles/?`,
    permissions: [],
    activeChip: {
      isActive: false,
      color: Colors.red[500],
      label: "",
    },
  },
  law_firm: {
    fieldName: "law_firm",
    title: "Law Firms",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Law Firms",
    showForm: false,
    options:[],
    selectedValue: [],
    checked: [],
    orderingVal: "order",
    nameKey: "name",
    valueKey: "pk",
    apiUrl: `/api/lawfirm/?`,
    permissions: ["lawyer.view_lawfirm"],
    activeChip: {
      isActive: false,
      color: Colors.yellow[500],
      label: "",
    },
  },
  status: {
    fieldName: "status",
    title: "Medical Status",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Medical Status",
    dashboardWidgetSelections:[],
    showForm: false,
    options:[],
    selectedValue: [],
    checked: [],
    orderingVal: "order",
    nameKey: "label",
    valueKey: "key",
    apiUrl: `/api/field_options/?content_type=case&field_name=status&`,
    permissions: [],
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  legal_status: {
    fieldName: "legal_status",
    title: "Legal Status",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Medical Status",
    showForm: false,
    options:[],
    selectedValue: [],
    checked: [],
    orderingVal: "order",
    nameKey: "label",
    valueKey: "key",
    apiUrl: `/api/field_options/?content_type=case&field_name=legal_status&`,
    permissions: [],
    activeChip: {
      isActive: false,
      color: Colors.green[400],
      label: "",
    },
  },

  overall_status: {
    fieldName: "overall_status",
    title: "Case Status",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Case Status",
    showForm: false,
    options:[],
    selectedValue: [],
    checked: [],
    orderingVal: "order",
    nameKey: "label",
    valueKey: "key",
    apiUrl: `/api/field_options/?content_type=case&field_name=overall_status&`,
    permissions: [],
    activeChip: {
      isActive: false,
      color: Colors.green[500],
      label: "",
    },
  },
  created_at: {
    fieldName: "created_at",
    title: "Date Created",
    filterType: "DateRange",
    currentValues: {
      __gte: undefined,
      __lte: undefined,
    },
    permissions: [],
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  last_note: {
    fieldName: "last_note",
    title: "Last Note Added",
    filterType: "DateRange",
    currentValues: {
      __gte: undefined,
      __lte: undefined,
    },
    permissions: [],
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  last_appointment: {
    fieldName: "last_appointment",
    title: "Last Appointment Added",
    filterType: "DateRange",
    currentValues: {
      __gte: undefined,
      __lte: undefined,
    },
    permissions: [],
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  actual_total_settlement_amount: {
    fieldName: "actual_total_settlement_amount",
    title: "Settlement Amount",
    filterType: "RangeSlider",
    currentValues: {
      __gte: undefined,
      __lte: undefined,
    },
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  medical_limit: {
    fieldName: "medical_limit",
    title: "Medical Limits Available",
    filterType: "RangeSlider",
    currentValues: {
      __gte: undefined,
      __lte: undefined,
    },
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  property_damage_amount: {
    fieldName: "property_damage_amount",
    title: "Property Damage Amount",
    filterType: "RangeSlider",
    currentValues: {
      __gte: undefined,
      __lte: undefined,
    },
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  running_total: {
    fieldName: "running_total",
    title: "Received Bill Charges",
    filterType: "RangeSlider",
    currentValues: {
      __gte: undefined,
      __lte: undefined,
    },
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },

  related_cases: {
    fieldName: "related_cases",
    title: "Related Cases",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Related Cases",
    showForm: false,
    options:[],
    selectedValue: [],
    checked: [],
    nameKey: "name",
    valueKey: "pk",
    apiUrl: `/api/case/?`,
    permissions: [],
    activeChip: {
      isActive: false,
      color: Colors.green[500],
      label: "",
    },
  },
  doc_type: {
    fieldName: "doc_type",
    title: "Uploaded Document Type",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Uploaded Document Types",
    showForm: false,
    options:[],
    selectedValue: [],
    checked: [],
    nameKey: "label",
    valueKey: "key",
    orderingVal: "label",
    apiUrl: `/api/field_options/?content_type=document&field_name=document_type&ordering=order&`,
    permissions: [],
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  entity: {
    fieldName: "entity",
    title: "Entities",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Entities",
    showForm: false,
    options:[],
    selectedValue: [],
    checked: [],
    nameKey: "name",
    valueKey: "pk",
    orderingVal: "label",
    apiUrl: `/api/entities/?is_related_to_law_firm=true&`,
    permissions: ["users.view_entity"],
    activeChip: {
      isActive: false,
      color: Colors.sky[500],
      label: "",
    },
  },
  incident_location: {
    fieldName: "incident_location",
    title: "Incident State",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Incident State",
    showForm: false,
    options:[],
    selectedValue: [],
    checked: [],
    nameKey: "label",
    valueKey: "key",
    orderingVal: "label",
    apiUrl: `/api/field_options/?content_type=case&field_name=incident_location&`,
    permissions: [],
    activeChip: {
      isActive: false,
      color: Colors.yellow[500],
      label: "",
    },
  },
  incident_location__not_in: {
    fieldName: "incident_location__not_in",
    title: "Incident not in State",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Incident not in State",
    showForm: false,
    options:[],
    selectedValue: [],
    checked: [],
    nameKey: "label",
    valueKey: "key",
    orderingVal: "label",
    apiUrl: `/api/field_options/?content_type=case&field_name=incident_location&`,
    permissions: [],
    activeChip: {
      isActive: false,
      color: Colors.orange[500],
      label: "",
    },
  },
  doc_type_not__in: {
    fieldName: "doc_type_not__in",
    title: "Not Uploaded Document Type",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Not Uploaded Document Type",
    showForm: false,
    options:[],
    selectedValue: [],
    checked: [],
    orderingVal: "label",
    nameKey: "label",
    valueKey: "key",
    orderingVal: "label",
    apiUrl: `/api/field_options/?content_type=document&field_name=document_type&ordering=order&`,
    permissions: [],
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  campaign: {
    fieldName: "campaign",
    title: "Campaign",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Campaign",
    showForm: false,
    options:[],
    selectedValue: [],
    checked: [],
    nameKey: "name",
    valueKey: "pk",
    apiUrl: `/api/leads/campaigns/?`,
    permissions: ["leads.view_all_campaigns"],
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },

  liability_request_status: {
    fieldName: "liability_request_status",
    title: "Liability Request",
    filterType: "SingleSelect",
    selectedValue: [],
    checked: [],
    orderingVal: "order",
    nameKey: "label",
    valueKey: "key",
    apiUrl: `/api/field_options/?content_type=clientcoverage&field_name=liability_request_status&`,
    permissions: [],
    activeChip: {
      isActive: false,
      color: Colors.amber[500],
      label: "",
    },
  },
  // liability_status: {
  //   fieldName: "liability_status",
  //   title: "Liability Status",
  //   filterType: "SingleSelect",
  //   selectedValue: [],
  //   checked:[],
  //   nameKey: "label",
  //   valueKey: "key",
  //   orderingVal: "order",
  //   apiUrl: `/api/field_options/?content_type=clientcoverage&field_name==liability_status&`,
  //   permissions: [],
  //   activeChip: {
  //     isActive: false,
  //     color: Colors.gray[400],
  //     label: "",
  //   },
  // },
  property_damage_severity: {
    fieldName: "property_damage_severity",
    title: "PD Severity",
    filterType: "SingleSelect",
    selectedValue: [],
    checked: [],
    nameKey: "label",
    valueKey: "key",
    orderingVal: "order",
    apiUrl: `/api/field_options/?content_type=case&field_name=property_damage_severity&`,
    permissions: [],
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  lost: {
    fieldName: "lost",
    title: "Lost",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Lost Cases",
    showForm: false,
    options:[],
    selectedValue: [],
    checked: [],
    activeChips: [],
    nameKey: "reason",
    valueKey: "id",
    apiUrl: `/api/lost_case_options/?`,
    permissions: [],
    activeChip: {
      isActive: false,
      color: Colors.red[500],
      label: "",
    },
  },
  client__date_of_birth: {
    fieldName: "client__date_of_birth",
    title: "Date of Birth",
    filterType: "DatePicker",
    selectedValue: null,
    permissions: [],
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  date_of_accident: {
    fieldName: "date_of_accident",
    title: "Date of Accident",
    filterType: "DatePicker",
    selectedValue: null,
    permissions: [],
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  date_of_accident2: {
    fieldName: "date_of_accident",
    title: "Date of Accident",
    filterType: "DateRange",
    currentValues: {
      __gte: undefined,
      __lte: undefined,
    },
    permissions: [],
    activeChip: {
      isActive: false,
      color: Colors.orange[500],
      label: "",
    },
  },

  updated_at: {
    fieldName: "updated_at",
    title: "Date Updated",
    filterType: "DateRange",
    currentValues: {
      __gte: undefined,
      __lte: undefined,
    },
    permissions: [],
    activeChip: {
      isActive: false,
      color: Colors.amber[500],
      label: "",
    },
  },

  archived: {
    fieldName: "archived",
    title: "Archived",
    filterType: "SearchOptionGroup",
    selectedValue: null,
    customFalseLabel: null,
    customTrueLabel: null,
    permissions: [],
    activeChip: {
      isActive: false,
      color: Colors.green[500],
      label: "",
    },
  },
  property_damage_severity__isnull: {
    fieldName: "property_damage_severity__isnull",
    title: "Needs PD Severity",
    filterType: "SearchOptionGroup",
    selectedValue: null,
    customFalseLabel: null,
    customTrueLabel: null,
    permissions: [],
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  campaign__isnull: {
    fieldName: "campaign__isnull",
    title: "Source",
    filterType: "SearchOptionGroup",
    selectedValue: null,
    customFalseLabel: "HnS",
    customTrueLabel: "Non HnS",
    permissions: [],
    activeChip: {
      isActive: false,
      color: Colors.purple[500],
      label: "",
    },
  },
  has_law_firm_cm: {
    fieldName: "has_law_firm_cm",
    title: "Has Law Firm CM",
    filterType: "SearchOptionGroup",
    selectedValue: null,
    customFalseLabel: null,
    customTrueLabel: null,
    permissions: [],
    activeChip: {
      isActive: false,
      color: Colors.red[500],
      label: "",
    },
  },
  police_report_received: {
    fieldName: "police_report_received",
    title: "Police Report",
    filterType: "SearchOptionGroup",
    selectedValue: null,
    customFalseLabel: null,
    customTrueLabel: null,
    permissions: [],
    activeChip: {
      isActive: false,
      color: Colors.sky[500],
      label: "",
    },
  },
};